import { AuthLayout } from "@/layouts/AuthLayout";
import { useMobileScreen } from "@/shared/hooks/useMobileScreen";
import EmailVerifiedIcon from "@/shared/components/@Icons/EmailVerifiedIcon";
import {
  Anchor,
  Button,
  Flex,
  Text,
  Title,
  rem,
  useMantineTheme,
} from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import { ResetPasswordForm } from "./components/ResetPasswordForm";
import { useResetPasswordController } from "./hooks/useResetPasswordController";
import { RoutePaths } from "@/core/constants";

export default function ResetPasswordPage() {
  const { isMobileScreen } = useMobileScreen();
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { form, loading, handleResetPassword, passwordReset } =
    useResetPasswordController();

  const footer = (
    <Anchor
      component={Link}
      to={RoutePaths.LOGIN}
      td={"none"}
      style={{
        display: "flex",
        alignSelf: "center",
        flexDirection: "row",
        alignItems: "center",
        gap: rem(4),
      }}>
      <IconArrowLeft size={24} />
      <Text
        fz={16}
        fw={700}
        component="span">
        Voltar ao login
      </Text>
    </Anchor>
  );

  const title = passwordReset ? null : (
    <Text
      component="h2"
      ff={"heading"}
      fw={700}
      fz={isMobileScreen ? 24 : 28}>
      Digite sua nova senha
    </Text>
  );

  return (
    <AuthLayout
      title={title}
      footer={passwordReset ? null : footer}>
      {passwordReset ? (
        <Flex
          direction={"column"}
          align="center"
          maw={rem(640)}
          w={"100%"}
          style={{
            flexGrow: 1,
          }}>
          <Flex
            direction="column"
            align="center"
            gap={rem(24)}
            style={{ flexGrow: 1 }}
            justify="start">
            <EmailVerifiedIcon
              color={theme.colors["R500"][0]}
              opacity={0.7}
            />

            <div>
              <Title
                order={2}
                ta="center"
                mb={rem(12)}
                c={theme.colors["plain_text"][0]}>
                Sua senha{" "}
                <span style={{ color: theme.colors["R500"][0] }}>
                  foi redefinida!
                </span>
              </Title>
              <Text
                ta="center"
                fz={rem(16)}
                c={theme.colors["L750"][0]}>
                Agora você já pode fazer login na sua conta com a nova senha.
              </Text>
            </div>

            <Button
              fullWidth
              mt={rem(24)}
              size="md"
              radius={rem(8)}
              bg={theme.colors["contrast_text"][0]}
              ff={"Outfit, sans-serif"}
              onClick={() => navigate(RoutePaths.LOGIN, { replace: true })}>
              Ir para o login
            </Button>
          </Flex>
        </Flex>
      ) : (
        <ResetPasswordForm
          form={form}
          loading={loading}
          onSubmit={handleResetPassword}
        />
      )}
    </AuthLayout>
  );
}
